import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import React, { Component } from 'react';
import {
  Col,
  FormControl,
  FormGroup,
  Grid,
  InputGroup,
  Navbar,
  Row
} from 'react-bootstrap';
import { connect } from 'react-redux';
// react component for creating dynamic tables
import ReactTable from 'react-table';
//Redux
import { bindActionCreators } from 'redux';
import * as CollectionsActions from './redux/CollectionsActions';

class CollectionsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
    console.log('Props', props);
  }

  componentWillMount() {
    this.props.find({});
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  render() {
    let _this = this;
    let { history, Collections } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Colecciones'}{' '}
                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() =>
                          history.push('/admin/collections/create')
                        }
                      >
                        Agregar Colección
                      </Button>
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Collections.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={
                      Collections.searchData
                        ? Collections.searchData
                        : Collections.data
                    }
                    page={Collections.table.page}
                    sorted={Collections.table.sorted}
                    filtered={Collections.table.filtered}
                    pageSize={Collections.table.pageSize}
                    onSortedChange={change =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={change =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={change =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={change =>
                      _this.props.changeTable('pageSize', change)
                    }
                    filterable
                    columns={[
                      {
                        Header: 'Nombre',
                        accessor: 'title'
                      },
                      {
                        Header: 'Categoría',
                        accessor: 'category',
                        minWidth: 120
                      },
                      {
                        Header: 'Subcategoría',
                        accessor: 'subcategory'
                      },
                      {
                        Header: 'Actions',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: props => (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <Button
                              onClick={() =>
                                history.push(
                                  '/admin/collections/' + props.original.id
                                )
                              }
                              bsStyle="warning"
                              simple
                            >
                              Editar
                            </Button>{' '}
                            {/* <Switch
                                                            onText="On"
                                                            offText="Off"
                                                        /> */}
                          </div>
                        )
                      }
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    Collections: state.Collections
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(CollectionsActions, dispatch);
};

const CollectionsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionsIndex);

export default CollectionsConnect;



// WEBPACK FOOTER //
// ./src/views/Collections/CollectionsIndex.jsx